<style lang="scss" scoped>
#comment_container {
  // max-height: 600px;
  overflow-y: auto;
  border: 2px #333;
  padding: 0;
  margin: 0;
  background-color: #f1f1f1;
}
.headline {
  font-size: 20px !important;
}
.comment {
  color: black !important;
}
</style>

<template>
  <div class="comments-tab">
    <v-card-title>
      <v-row>
        {{ $capitalize($tc("model.comments_comments_page_title")) }}
        <v-spacer></v-spacer>
        <v-btn icon @click="getComments" :loading="loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn
          @click="see_last_comments = true"
          text
          v-if="see_last_comments == false && comments.length > 3"
        >
          {{ $capitalize($tc("model.comments_previous_comments")) }} ({{ comments.length - 3 }})
        </v-btn>
        <v-btn
          @click="see_last_comments = false"
          text
          v-else-if="see_last_comments == true"
        >
          {{ $capitalize($tc("model.comments_hide_old_comments")) }}
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text id="comment_container">
      <empty-state
        :when="comments.length == 0"
        :message="
          $capitalize($tc('model.comments_no_comments'))
        "
        outlined
        height="300"
      >
        <div v-for="comment in filtered_comments" :key="comment.id">
          <v-card class="my-2" flat style="padding: 5px" outlined>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline">{{
                  comment.title
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-avatar>
                <user-avatar
                  :avatar_url="comment.user.avatar_url"
                  :user_name="comment.user.name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{
                  comment.user ? comment.user.name : comment.created_by
                }}</v-list-item-title>
                <v-list-item-subtitle>
                  <span v-if="comment.created_on">{{
                    toDateString(comment.created_on)
                  }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-card-text class="text-justify comment">{{
              comment.description
            }}</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <span class="mr-3">
                <v-icon class="mr-1">mdi-paperclip</v-icon>0
              </span>
              <span class="mr-3">
                <v-icon class="mr-1">mdi-comment</v-icon>0
              </span>
              <span class="mr-3">
                <v-icon
                  class="mr-1"
                  :title="
                    $capitalize($tc('model.comments_submitted_by_integration'))
                  "
                  v-if="comment.external_reference"
                  color="blue"
                  >mdi-check</v-icon
                >
              </span>
            </v-card-actions>
          </v-card>
        </div>
      </empty-state>
    </v-card-text>
    <ScopeProvider scope="leads.comments.add">
      <v-card class="mt-5" outlined>
        <ValidationObserver ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="sendComment">
            <v-card-title>{{ $capitalize($tc("model.comments_send_feedback")) }}</v-card-title>
            <v-card-text>
              <ValidationProvider
                name="title"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="form.title"
                  name="title"
                  :error-messages="errors"
                  :label="
                    $capitalize($tc('model.comments_comment_title'))
                  "
                  filled
                  :counter="256"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="description"
                rules="required"
                v-slot="{ errors }"
              >
                <v-textarea
                  v-model="form.description"
                  name="description"
                  :label="
                    $capitalize($tc('model.comments_comment_description'))
                  "
                  filled
                  :error-messages="errors"
                  :counter="512"
                ></v-textarea>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="resetForm" text>{{ $capitalize($tc("model.comments_clean_button")) }}</v-btn>
              <v-btn
                type="submit"
                color="primary"
                :loading="sending_message"
                :disabled="invalid"
              >
                <v-icon size="17" class="mr-1">mdi-send</v-icon>{{ $capitalize($tc("model.comments_send_button")) }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </ScopeProvider>
  </div>
</template>

<script>
import { formatDateTime } from "../../tools/date";
import ScopeProvider from "@/components/ScopeProvider";
import EmptyState from "@/components/EmptyState";
import UserAvatar from "@/components/UserAvatar";

export default {
  name: "comments-tab",
  components: { EmptyState, ScopeProvider, UserAvatar },
  data: () => ({
    comments: [],
    loading: false,
    sending_message: false,
    see_last_comments: false,
    form: {},
  }),
  methods: {
    toDateString(raw_date) {
      const date = this.$moment(raw_date);

      return this.$moment.duration(date.diff(this.$moment())).humanize(true);
    },
    async getComments() {
      this.comments = [];
      this.loading = true;
      try {
        const response = await this.$http.get(
          `/leads/${this.$route.params["lead_number"]}/comments`
        );

        this.comments = response.data;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao consultar comentários",
          color: "red",
        });
      } finally {
        this.loading = false;
      }
    },
    async sendComment() {
      const payload = {
        ...this.form,
        category_code: "123",
        sub_category_code: "123",
      };

      const validation = await this.$refs.form.validate();

      if (validation) {
        this.loading = true;
        this.sending_message = true;
        try {
          const response = await this.$http.post(
            `/leads/${this.$route.params["lead_number"]}/comment`,
            payload
          );

          this.comments = response.data;
          this.form = {};
          this.$refs.form.reset();
          this.$store.commit("sendMessage", {
            text: "Comentário enviado!",
            color: "green",
          });
        } catch (error) {
          this.$store.commit("sendMessage", {
            text: "Falha ao enviar comentários",
            color: "red",
          });
        } finally {
          this.loading = false;
          this.sending_message = false;
        }
      }
    },
    resetForm() {
      this.form = {};
      this.$refs.form.reset();
    },
  },
  computed: {
    lead: function () {
      return this.$store.getters.getLead;
    },
    filtered_comments: function () {
      return this.comments.filter((comment, index) => {
        if (this.see_last_comments) {
          return true;
        } else {
          return index > this.comments.length - 4;
        }
      });
    },
  },
  created() {
    this.getComments();
  },
};
</script>